import { useFormController } from "./useFormController";

/**
 * Hook providing access to the "submitting" status of a form in context.
 * @throws {NoFormContextError} When no form is in context.
 * @returns Whether the form in context is being submitted.
 */
export function useSubmitting(): boolean {
  return useFormController().useSubmitting();
}
